import {BeautifulMentionsMenuItemProps} from 'lexical-beautiful-mentions';
import {HStack} from 'platform/foundation';
import {cn, cva} from 'platform/shared';

import {ComponentPropsWithRef, Ref, useContext} from 'react';

import {isNotNil, omit} from 'ramda';

import {StatusIndicatorDot} from '../../Choice/utils/StatusIndicatorDot';
import {MenuItemStatusIndicatorContext} from './MenuItemStatusIndicatorContext';

const menuItemVariants = cva(
  'list-none rounded-[var(--radius-small)] p-2 !text-[length:var(--text-size-small)]',
  {
    variants: {
      isSelected: {
        true: 'bg-[var(--color-palettes-blue-10-100)] text-[var(--color-palettes-blue-80-100)]',
        false: '',
      },
    },
    defaultVariants: {
      isSelected: false,
    },
  }
);

export interface StyledMenuItemProps extends ComponentPropsWithRef<'li'> {
  $isSelected?: boolean;
}

export function StyledMenuItem(props: StyledMenuItemProps) {
  const htmlProps = omit(['$isSelected'], props);

  return (
    <li
      {...htmlProps}
      className={cn(menuItemVariants({isSelected: props.$isSelected}), props.className)}
    />
  );
}

interface CustomMenuItemProps extends BeautifulMentionsMenuItemProps {
  ref?: Ref<HTMLLIElement>;
}

export function CustomMenuItem(props: CustomMenuItemProps) {
  const statusIndicatorById = useContext(MenuItemStatusIndicatorContext);

  const itemId = props.item?.data?.id;
  const statusIndicator = typeof itemId === 'string' ? statusIndicatorById.get(itemId) : undefined;
  const menuItemProps = omit(['selected', 'item', 'children'], props);

  return (
    <StyledMenuItem {...menuItemProps} $isSelected={props.selected}>
      {isNotNil(statusIndicator) ? (
        <HStack align="center" spacing={1}>
          {props.children}
          <StatusIndicatorDot statusIndicator={statusIndicator} />
        </HStack>
      ) : (
        props.children
      )}
    </StyledMenuItem>
  );
}
